var map = {
	"./Gruppe 4672.svg": 372,
	"./award.svg": 117,
	"./brandimage.svg": 373,
	"./bubbles.svg": 65,
	"./c_bubble.svg": 118,
	"./careandcoach_white.svg": 116,
	"./chat-icon.svg": 119,
	"./check-circle-2.svg": 66,
	"./check-circle-fill.svg": 374,
	"./clock-history.svg": 120,
	"./creditcards.svg": 108,
	"./dash-circle.svg": 121,
	"./diploma-icon.svg": 122,
	"./download.svg": 84,
	"./edit.svg": 67,
	"./element-navigation.svg": 68,
	"./facebook.svg": 158,
	"./facebookSocials.svg": 162,
	"./fullScreenArrows.svg": 123,
	"./homepage/perks1.svg": 124,
	"./homepage/perks2.svg": 125,
	"./homepage/perks3.svg": 126,
	"./homepage/perks4.svg": 127,
	"./instagram.svg": 111,
	"./instagramSocials.svg": 163,
	"./invoice.svg": 109,
	"./invoice_footer.svg": 114,
	"./kurgebuehr.svg": 128,
	"./linkedin.svg": 159,
	"./linkedinSocials.svg": 164,
	"./logo-white.svg": 375,
	"./logo.svg": 376,
	"./logo_text--white.svg": 377,
	"./logo_text.svg": 378,
	"./mastercard-white.svg": 115,
	"./newsletter-element-1.svg": 129,
	"./newsletter-element-2.svg": 130,
	"./patch-check.svg": 131,
	"./paypal.svg": 110,
	"./paypal_footer.svg": 113,
	"./play-circle-fill.svg": 379,
	"./play_continue.svg": 380,
	"./play_module.svg": 381,
	"./plus-circle.svg": 132,
	"./quiz-disabled.svg": 382,
	"./quiz-enabled.svg": 383,
	"./quiz-ending-happy.svg": 69,
	"./quiz-ending-sad.svg": 133,
	"./speedometer.svg": 134,
	"./trophy-icon.svg": 135,
	"./twitter.svg": 161,
	"./twitterSocials.svg": 165,
	"./visa-white.svg": 112,
	"./youtube.svg": 160,
	"./youtubeSocials.svg": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;